import * as React from 'react';
import { DotLoading } from 'antd-mobile';

import styles from './index.module.scss';

function PageLoading() {
    return (
        <div className={styles.pageLoading}>
            <DotLoading color="--adm-color-primary" />
        </div>
    );
}

export default PageLoading;
